module.exports = __webpack_public_path__ + "img/4-1.ab634b8e.jpg";